// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
:host section {
  background-color: #ffffff;
}
:host .nav-item {
  border-left: solid transparent 5px;
  border-right: solid transparent 5px;
}
:host .paint-icon-container ::ng-deep .icon.folder {
  font-size: 1.5rem;
}
:host .active {
  background-color: rgba(7, 139, 203, 0.2);
}
:host .active ::ng-deep .folder-svg {
  fill: #078BCB;
}
:host .active ::ng-deep .silhouettes-svg,
:host .active ::ng-deep .home-svg,
:host .active ::ng-deep .menu-folder-svg,
:host .active ::ng-deep .database-svg,
:host .active ::ng-deep .project-description-svg,
:host .active ::ng-deep .invoices,
:host .active ::ng-deep .calendar,
:host .active ::ng-deep .gear-svg {
  stroke: #078BCB;
}
:host .faIcon {
  font-size: 2.25rem;
}
:host .activeFaIcon {
  color: #078BCB;
}
:host .logo-container {
  position: fixed;
  bottom: 6rem;
  height: 14rem;
  width: 3rem;
}
:host .logo-image {
  height: 100%;
  object-fit: contain;
}
:host .intercom-launcher-logo {
  height: 50px;
  width: 50px;
}
:host .hover-highlight-svg:hover > svg-icon {
  fill: #222222;
}
:host .hover-highlight-faIcon:hover {
  color: #222222;
}
@media only screen and (max-height: 820px) {
  :host .logo-container {
    bottom: 40px;
  }
  :host .logo-image {
    height: 80%;
  }
}
@media only screen and (max-height: 700px) {
  :host .logo-container {
    position: inherit;
    height: 5rem;
  }
  :host .icon {
    margin-top: 1rem;
  }
  :host .logo-image {
    display: none;
  }
}
:host ::ng-deep .popover {
  border-radius: 0;
  margin-left: 0;
  width: 200px;
}
:host ::ng-deep .popover-arrow {
  display: none;
}
:host ::ng-deep .popover-body {
  border-top: 3px solid black;
  padding-top: 0;
}
:host .disabled-sidenav-button {
  pointer-events: none;
}
:host .my-scrollable-list {
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
:host .my-scrollable-list::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/@itc-core/components/navigation-panels/navigation-menu/navigation-menu.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC1DC;EACC,yBAAA;AAAF;AAKC;EACC,kCAAA;EACA,mCAAA;AAHF;AAMC;EACC,iBAAA;AAJF;AAOC;EACC,wCAAA;AALF;AAQG;EACC,aDrBM;ACeV;AASG;;;;;;;;EASC,eDjCM;ACyBV;AAaC;EACC,kBAAA;AAXF;AAcC;EACC,cD3CQ;AC+BV;AAeC;EACC,eAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AAbF;AAgBC;EACC,YAAA;EACA,mBAAA;AAdF;AAiBC;EACC,YAAA;EACA,WAAA;AAfF;AAkBC;EACC,aDrCU;ACqBZ;AAmBC;EACC,cDzCU;ACwBZ;AAoBC;EACC;IACC,YAAA;EAlBD;EAoBA;IACC,WAAA;EAlBD;AACF;AAqBC;EACC;IACC,iBAAA;IACA,YAAA;EAnBD;EAqBA;IACC,gBAAA;EAnBD;EAqBA;IACC,aAAA;EAnBD;AACF;AAwBE;EACC,gBAAA;EACA,cAAA;EACA,YAAA;AAtBH;AAyBE;EACC,aAAA;AAvBH;AA0BE;EACC,2BAAA;EACA,cAAA;AAxBH;AA4BC;EACC,oBAAA;AA1BF;AA6BC;EACC,kBAAA;EACA,wBAAA;EACA,qBAAA;AA3BF;AA8BC;EACC,aAAA;AA5BF","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n:host {\n\tsection {\n\t\tbackground-color: #ffffff;\n\t}\n\n\t// this is needed to avoid jumping of the element when adding\n\t// 5px border-left for selected state and have the icons centred still\n\t.nav-item {\n\t\tborder-left: solid transparent 5px;\n\t\tborder-right: solid transparent 5px;\n\t}\n\n\t.paint-icon-container ::ng-deep .icon.folder {\n\t\tfont-size: 1.5rem;\n\t}\n\n\t.active {\n\t\tbackground-color: rgba($primary, 0.2);\n\n\t\t::ng-deep {\n\t\t\t.folder-svg {\n\t\t\t\tfill: $primary;\n\t\t\t}\n\n\t\t\t.silhouettes-svg,\n\t\t\t.home-svg,\n\t\t\t.menu-folder-svg,\n\t\t\t.database-svg,\n\t\t\t.project-description-svg,\n\t\t\t,\n\t\t\t.invoices,\n\t\t\t.calendar,\n\t\t\t.gear-svg {\n\t\t\t\tstroke: $primary;\n\t\t\t}\n\t\t}\n\t}\n\n\t.faIcon {\n\t\tfont-size: 2.25rem;\n\t}\n\n\t.activeFaIcon {\n\t\tcolor: $primary;\n\t}\n\n\t.logo-container {\n\t\tposition: fixed;\n\t\tbottom: 6rem;\n\t\theight: 14rem;\n\t\twidth: 3rem;\n\t}\n\n\t.logo-image {\n\t\theight: 100%;\n\t\tobject-fit: contain;\n\t}\n\n\t.intercom-launcher-logo {\n\t\theight: 50px;\n\t\twidth: 50px;\n\t}\n\n\t.hover-highlight-svg:hover > svg-icon {\n\t\tfill: $secondary;\n\t}\n\n\t.hover-highlight-faIcon:hover {\n\t\tcolor: $secondary;\n\t}\n\n\t@media only screen and (max-height: 820px) {\n\t\t.logo-container {\n\t\t\tbottom: 40px;\n\t\t}\n\t\t.logo-image {\n\t\t\theight: 80%;\n\t\t}\n\t}\n\n\t@media only screen and (max-height: 700px) {\n\t\t.logo-container {\n\t\t\tposition: inherit;\n\t\t\theight: 5rem;\n\t\t}\n\t\t.icon {\n\t\t\tmargin-top: 1rem;\n\t\t}\n\t\t.logo-image {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t// Popover styles\n\t::ng-deep {\n\t\t.popover {\n\t\t\tborder-radius: 0;\n\t\t\tmargin-left: 0;\n\t\t\twidth: 200px;\n\t\t}\n\n\t\t.popover-arrow {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t.popover-body {\n\t\t\tborder-top: 3px solid black;\n\t\t\tpadding-top: 0;\n\t\t}\n\t}\n\n\t.disabled-sidenav-button {\n\t\tpointer-events: none;\n\t}\n\n\t.my-scrollable-list {\n\t\toverflow-y: scroll;\n\t\t-ms-overflow-style: none;\n\t\tscrollbar-width: none;\n\t}\n\n\t.my-scrollable-list::-webkit-scrollbar {\n\t\tdisplay: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
